module.exports = __webpack_public_path__ + "static/img/img.e1ec24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-field-call/img.png
// module id = HkUS
// module chunks = 4